import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=75556afc&scoped=true&"
import script from "./type3.vue?vue&type=script&lang=js&"
export * from "./type3.vue?vue&type=script&lang=js&"
import style0 from "./type3.vue?vue&type=style&index=0&id=75556afc&prod&scoped=true&lang=css&"
import style1 from "./type3.vue?vue&type=style&index=1&id=75556afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75556afc",
  null
  
)

export default component.exports